<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
            name="Add Details"
            bc1="App"
            bc2="Privilege"
            bc3="Add"
            path="privilege"
          ></Breadcrumb>
        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Add Details</h4>
                </div>
                <div class="card-body">
                  <form class="form form-horizontal">
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Currency Payment Method</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <b-form-select
                                v-model="currencyPaymentMethodId"
                                size="sm"
                                v-validate="'required'"
                                name="currencyPaymentMethodId"
                                class="mt-1"
                                :class="
                                  errorBag.has('currencyPaymentMethodId')
                                    ? 'is-invalid'
                                    : ''
                                "
                              >
                                <b-form-select-option value=""
                                  >Select Payment Method</b-form-select-option
                                >
                                <b-form-select-option
                                  v-for="(item, index) in requestCurrencyPaymentData"
                                  :key="index"
                                  :value="item.id"
                                  >{{ item.currency.name }} /
                                  {{ item.payment_method.name }}
                                </b-form-select-option>
                              </b-form-select>
                              <small
                                v-show="errorBag.has('currencyPaymentMethodId')"
                                class="invalid-feedback"
                                >{{
                                  "*" +
                                    errorBag.first("currencyPaymentMethodId")
                                }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Transaction Type</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <b-form-select
                                v-model="transactionTypeId"
                                size="sm"
                                name="transactionTypeId"
                                v-validate="'required'"
                                class="mt-1"
                                :class="
                                  errorBag.has('transactionTypeId')
                                    ? 'is-invalid'
                                    : ''
                                "
                              >
                                <b-form-select-option value=""
                                  >Please Select transaction type
                                </b-form-select-option>
                                <b-form-select-option
                                  v-for="(item, index) in transactionData"
                                  :key="index"
                                  :value="item.id"
                                  >{{ item.name }}
                                </b-form-select-option>
                              </b-form-select>
                              <small
                                v-show="errorBag.has('transactionTypeId')"
                                class="invalid-feedback"
                                >{{
                                  "*" + errorBag.first("transactionTypeId")
                                }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="name-icon">minLimit</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <input
                                type="text"
                                v-model="minLimit"
                                class="form-control"
                                :class="
                                  errorBag.has('minLimit') ? 'is-invalid' : ''
                                "
                                name="minLimit"
                                placeholder="Min Limit"
                                v-validate="'required'"
                              />
                              <small
                                v-show="errorBag.has('minLimit')"
                                class="invalid-feedback"
                                >{{ "*" + errorBag.first("minLimit") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="name-icon">Max Limit</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <input
                                type="text"
                                v-model="maxLimit"
                                class="form-control"
                                :class="
                                  errorBag.has('maxLimit') ? 'is-invalid' : ''
                                "
                                name="maxLimit"
                                placeholder="Max Limit"
                                v-validate="'required'"
                              />
                              <small
                                v-show="errorBag.has('maxLimit')"
                                class="invalid-feedback"
                                >{{ "*" + errorBag.first("maxLimit") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="name-icon">Foreign Charge</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <input
                                type="text"
                                v-model="foreignCharge"
                                class="form-control"
                                :class="
                                  errorBag.has('foreignCharge')
                                    ? 'is-invalid'
                                    : ''
                                "
                                name="foreignCharge"
                                placeholder="Foreign Charge"
                                v-validate="'required'"
                              />
                              <small
                                v-show="errorBag.has('foreignCharge')"
                                class="invalid-feedback"
                                >{{
                                  "*" + errorBag.first("foreignCharge")
                                }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="name-icon">Processing Time</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <input
                                type="text"
                                v-model="processingTime"
                                class="form-control"
                                :class="
                                  errorBag.has('processingTime')
                                    ? 'is-invalid'
                                    : ''
                                "
                                name="processingTime"
                                placeholder="Processing Time"
                                v-validate="'required'"
                              />
                              <small
                                v-show="errorBag.has('processingTime')"
                                class="invalid-feedback"
                                >{{
                                  "*" + errorBag.first("processingTime")
                                }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-sm-9 offset-sm-3 d-flex">
                        <button
                          type="button"
                          class="btn btn-primary mr-1 d-flex"
                          @click="sendCall"
                          :disabled="loading"
                        >
                          <Loader :loading="loading" :size="size"></Loader>
                          Submit
                        </button>
                        <button
                          type="button"
                          class="btn btn-gradient-secondary"
                          @click="$router.push({ name: 'privilege' })"
                        >
                          Back
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
import { CommandIcon } from "vue-feather-icons";
import { mapGetters } from "vuex";

export default {
  components: {
    CommandIcon
  },
  mounted() {
    setTimeout(() => {
      this.getTransactionData();
      this.getCurrencyPaymentData();
    }, 1000);
  },
  created() {},
  data() {
    return {
      requestCurrencyPaymentData : [],
      vpPercentageCharges: "",
      vpFixedCharges: "",
      currencyPaymentMethodId: "",
      transactionTypeId: "",
      gwPercentageCharges: "",
      gwFixedCharges: "",
      otherCharges: "",
      minLimit: "",
      maxLimit: "",
      foreignCharge: "",
      otherChargesType: "",
      processingTime: "",
      transactionData: [],
      currencyPaymentMethodData: [],
      loading: false,
      size: "10px"
    };
  },
  computed: {
    ...mapGetters({
      currencyPaymentData: "getByKey"
    })
  },
  methods: {
    getTransactionData() {
      this.makeRequest("post", "v1/transaction-types",{},{},false).then(response => {
        if (!response.error) {
          this.transactionData = response.response.data.data;
        }
      });
    },
    getCurrencyPaymentData() {
      this.makeRequest("post", "v1/get-currency-payment-method", {
        flag: "active"
      },{},false).then(response => {
        if (!response.error) {
          let data = [];
          data = response.response.data.data;
          this.requestCurrencyPaymentData = data
          // data.key = "setCurrencyPaymentForPrivilege";
          // this.$store.dispatch("set", data);
        }
      });
    },
    sendCall() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;
          // let data = new FormData();
          // data.append("application", "android");
          // data.append("applicationVersion", "1.33");
          // data.append("deviceId", "XXXXXXXXXXXXXXXXXXXXXXXX");
          // data.append("deviceDetail", "android s4 etc");
          // data.append("latitude", "");
          // data.append("longitude", "");
          // data.append("currencyPaymentMethodId", this.currencyPaymentMethodId);
          // data.append("transactionTypeId", this.transactionTypeId);
          // data.append("minLimit", this.minLimit * 100);
          // data.append("maxLimit", this.maxLimit * 100);
          // data.append("foreignCharge", this.foreignCharge * 100);
          // data.append("processingTime", this.processingTime);

          let data = {
            currencyPaymentMethodId : this.currencyPaymentMethodId,
            transactionTypeId : this.transactionTypeId,
            minLimit : this.minLimit * 100,
            maxLimit : this.maxLimit * 100,
            foreignCharge : this.foreignCharge * 100,
            processingTime : this.processingTime *100,
          }

          this.makeRequest("post", "v1/add-privilege", data).then(
            callResponse => {
              if (!callResponse.error) {
                let code = callResponse.response.data.code;
                if (code == 200) {
                  this.loading = false;
                  if (callResponse.response.data.data) {
                    let responseData = callResponse.response.data.data;
                    let storeData = this.$store.getters.getByKey("privilege");
                    if (typeof storeData.firstPageData != "undefined") {
                      storeData.firstPageData.data.unshift(responseData);
                      storeData.firstPageData.pagination.total = storeData.firstPageData.pagination.total + 1
                      if(storeData.firstPageData.pagination.perPage < storeData.firstPageData.pagination.total){
                        storeData.firstPageData.data.pop();
                      }
                      storeData.key = "privilege";
                      delete storeData.otherPageData;
                      this.$store.dispatch("set", storeData);
                    }
                    this.$router.push({
                      name: "privilege",
                      params: { add: true }
                    });
                  }
                } else if (code == 400) {
                  this.loading = false;
                }
              }
            }
          );
        }
      });
    }
  }
};
</script>

